<template>
  <div class="price-card">
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImgBg"
    :loading-icon="$placeImgBg"
     :src="cardData.cover_mobile || cardData.img_url || $placeImgBg" alt=""></van-image>
    <div class="price-msg">
      <div class="price-name ellipsis">{{ cardData.name }}</div>
      <div class="price-des ellipsis" v-if="desShow">{{ cardData.description }}</div>
      <!-- <div class="studyTime" v-if="studyTimShow">共{{ cardData.study_times }}学时</div> -->
      <!-- <div class="yingyouPrice"  v-if="plat!=120 && type!='live'" >¥ {{ cardData.price }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    },
    desShow:{
      type: Boolean,
      default: true
    },
    studyTimShow:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: 100%;
  margin-bottom: 32px;
  box-sizing: border-box;
  position: relative;
  .tip{
    position: absolute;
    top:0;
    left:0;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
  .studyTime{
    color: #999999;
    font-size: 20px;
  }
}

.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 100%;
  height: calc((100vw - 80px)*0.5* 9/16) ;
  border-radius: 12px;
  display: block;
  margin-right: 26px;
  overflow: hidden;
}

.price-msg {
  width: 100%;
  
}

.price-name {
  font-size: 28px;
  color: #000000;
  font-weight: 500;
  width: 100%;
  margin: 10px 0;
}

.price-des {
  font-size: 28px;  
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
}

.yingyouPrice {
  font-size: 24px;
  color: #F08E00;
  font-weight: 500;
}
</style>>
